var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`h-100 d-flex flex-column bg-${_vm.bgVariant || _vm.themeVariant}`},[_vm._t("header"),_c('div',{ref:"frame",class:`flex-grow-1 bg-${_vm.bgVariant || _vm.themeVariant}`,style:(`overflow-y: scroll; height: ${_vm.editorFullscreen ? '100vh' : '0px'}`),attrs:{"id":"frame"}},[_vm._t("content",null,{"frame":_vm.$refs.frame})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }